/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Import_Dashboard_TitleInputs */

const en_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Description Import`)
};

const fr_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du plan Importer`)
};

const de_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Description Import`)
};

const it_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione dello scatto Importazione`)
};

const ru_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание кадра Импорт`)
};

const es_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de la descripción de la toma`)
};

const zh_cn2_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述导入`)
};

const ja_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの説明インポート`)
};

const hi_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण आयात करें`)
};

const pt_pt2_scene_description_import_dashboard_title = /** @type {(inputs: Scene_Description_Import_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição da tomada Importação`)
};

/**
* | output |
* | --- |
* | "Shot Description Import" |
*
* @param {Scene_Description_Import_Dashboard_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_dashboard_title = /** @type {((inputs?: Scene_Description_Import_Dashboard_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_Dashboard_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_import_dashboard_title(inputs)
	if (locale === "de") return de_scene_description_import_dashboard_title(inputs)
	if (locale === "it") return it_scene_description_import_dashboard_title(inputs)
	if (locale === "ru") return ru_scene_description_import_dashboard_title(inputs)
	if (locale === "es") return es_scene_description_import_dashboard_title(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_import_dashboard_title(inputs)
	if (locale === "ja") return ja_scene_description_import_dashboard_title(inputs)
	if (locale === "hi") return hi_scene_description_import_dashboard_title(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_import_dashboard_title(inputs)
	return en_scene_description_import_dashboard_title(inputs)
});